import { MarketplaceGuestInfoDto } from "../../../../../../networking/data/responses/marketplace/MarketplaceGuestInfoDto";

export class MarketplaceGuestInfo {
    public readonly avatar: string;
    public readonly firstName: string;
    public readonly lastName?: string;

    public constructor(dto: MarketplaceGuestInfoDto) {
        if (dto == undefined) {
            throw new Error("Failed to create MarketplaceGuestInfo without MarketplaceGuestInfoDto.");
        }
        if (dto.avatar == undefined || dto.avatar.length == 0) {
            throw new Error("Failed to create MarketplaceGuestInfo without avatar url.");
        }
        if (dto.firstName == undefined || dto.firstName.length == 0) {
            throw new Error("Failed to create MarketplaceGuestInfo without first name.");
        }
        this.avatar = dto.avatar;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
    }
}